<template>
  <div>
    <el-dialog
      title="准入供应商查询"
      :close-on-click-modal="false"
      :visible.sync="viewData.visible"
      width="80%"
      :style="{ height: '1000px' }"
    >
      <div v-loading="dataListLoading">
        <el-table
          :data="dataList"
          size="mini"
          :row-class-name="rowClassName"
          :height="style.gridStyle.height"
          @selection-change="selectionChangeHandle"
          :header-cell-style="{ background: '#f5f5f5' }"
          border
        >
          <!-- 添加单选框列 -->
          <el-table-column width="50">
            <template #default="{ row }">
              <el-radio v-model="selectedRow" :label="row">{{ "" }}</el-radio>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            label="序号"
            align="center"
            width="50"
          >
            <template slot-scope="scope">
              {{ scope.row.rowid }}
            </template>
          </el-table-column>
          <el-table-column
            prop="venderName"
            header-align="center"
            align="left"
            label="供应商名称"
            min-width="60"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="venderUserDetail(scope.row)">
                {{ scope.row.venderName }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="venderContacts"
            header-align="center"
            align="left"
            label="联系人"
            min-width="60"
          >
            <template slot-scope="scope">
              {{ scope.row.venderContacts }}
            </template>
          </el-table-column>
          <el-table-column
            prop="venderTel"
            header-align="center"
            align="right"
            label="电话"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.venderTel }}
            </template>
          </el-table-column>
          <el-table-column
            prop="approveStore"
            header-align="center"
            align="right"
            label="审核得分"
            min-width="60"
          >
            <template slot-scope="scope">
              {{ scope.row.approveStore }}
            </template>
          </el-table-column>
          <el-table-column
            prop="approveClass"
            header-align="center"
            align="right"
            label="审核等级"
            min-width="60"
          >
            <template slot-scope="scope">
              {{ scope.row.approveClass }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            header-align="center"
            align="right"
            label="创建时间"
            min-width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column
            prop="inviteStauts"
            header-align="center"
            align="center"
            label="邀请状态"
            min-width="50"
          >
            <template slot-scope="scope">
              <span style="color: #409eff" v-if="scope.row.inviteStauts === 0"
                >未邀请</span
              >
              <span style="color: #67c23a" v-if="scope.row.inviteStauts === 1"
                >已邀请</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="isPru"
            header-align="center"
            align="center"
            label="生产供应商"
            min-width="60"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.isPru"
                :true-label="1"
                :false-label="0"
                disabled
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="isGen"
            header-align="center"
            align="center"
            label="综合供应商"
            min-width="60"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.isGen"
                :true-label="1"
                :false-label="0"
                disabled
              ></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
      <el-row :gutter="40">
        <el-col :span="24" style="text-align: right">
          <el-button size="small" @click="cancel()"> 取消 </el-button>
          <el-button size="small" type="primary" @click="dataFormSubmit()">
            确定
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 弹窗 供应商 查看 / 新增 / 修改 -->
    <el-dialog
      title="供应商信息"
      width="60%"
      :visible.sync="dialogVisibleDetail"
      :rules="dataRule"
      @close="closeDialog"
    >
      <el-tabs>
        <el-tab-pane class="tab_style" :key="1" label="基本信息">
          <div style="margin-top: 30px">
            <el-form
              :model="temp"
              label-width="160px"
              :rules="dataRule"
              size="mini"
              ref="temp"
              style="margin-top: 5px"
            >
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-tooltip placement="top" content="" effect="light">
                    <div slot="content">{{ temp.venderName }}</div>
                    <el-form-item label="供应商名称：" prop="venderName">
                      <el-input
                        :disabled="!showEditButton"
                        v-model="temp.venderName"
                      />
                    </el-form-item>
                  </el-tooltip>
                </el-col>
                <el-col :span="11">
                  <el-tooltip placement="top" content="" effect="light">
                    <div slot="content">{{ temp.venderAdd }}</div>
                    <el-form-item label="供应商地址：" prop="venderAdd">
                      <el-input disabled v-model="temp.venderAdd" />
                    </el-form-item>
                  </el-tooltip>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <div slot="content">{{ temp.isPru }}</div>
                  <el-form-item label="生产供应商：" prop="isPru">
                    {{ temp.isPru === 1 ? '是' : '否' }}

<!--                    <el-checkbox-->
<!--                      v-model="temp.isPru"-->
<!--                      :true-label="1"-->
<!--                      :false-label="0"-->
<!--                      :disabled="!showEditButton"-->
<!--                    ></el-checkbox>-->
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <div slot="content">{{ temp.isGen }}</div>
                  <el-form-item
                    label="综合供应商："
                    prop="isGen"
                  >
                    {{ temp.isGen === 1 ? '是' : '否' }}
<!--                    <el-checkbox-->
<!--                      v-model="temp.isGen"-->
<!--                      :true-label="1"-->
<!--                      :false-label="0"-->
<!--                      :disabled="!showEditButton"-->
<!--                    ></el-checkbox>-->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <div slot="content">{{ temp.supcompanyCode }}</div>
                  <el-form-item label="子公司代码：" prop="supcompanyCode">
                    <el-input disabled v-model="temp.supcompanyCode" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <div slot="content">{{ temp.supgroupCode }}</div>
                  <el-form-item label="采购组代码：" prop="supgroupCode">
                    <el-input disabled v-model="temp.supgroupCode" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <div slot="content">{{ temp.venderType }}</div>
                  <el-form-item label="企业类型：" prop="venderType">
                    <el-input disabled v-model="temp.venderType" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <div slot="content">{{ temp.venturePartner }}</div>
                  <el-form-item label="主要合资方：" prop="venturePartner">
                    <el-input disabled v-model="temp.venturePartner" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <div slot="content">{{ temp.empNum }}</div>
                  <el-form-item label="公司人数：" prop="empNum">
                    <el-input disabled v-model="temp.empNum" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <div slot="content">{{ temp.venderEdge }}</div>
                  <el-form-item label="企业经营范围：" prop="venderEdge">
                    <el-input disabled v-model="temp.venderEdge" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-form-item label="联系人：" prop="venderContacts">
                    <el-input disabled v-model="temp.venderContacts" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="联系电话：" prop="venderTel">
                    <el-input disabled v-model="temp.venderTel" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-form-item label="传真：" prop="venderFax">
                    <el-input disabled v-model="temp.venderMail" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="e-mail：" prop="venderMail">
                    <el-input disabled v-model="temp.venderMail" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-form-item label="归属平台：" prop="productName">
                    <el-input disabled v-model="temp.productName" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="审核结论：" prop="approveIssue">
                    <el-input type="textarea" disabled v-model="temp.approveIssue" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-form-item label="审核得分：" prop="approveStore">
                    <el-input disabled v-model="temp.approveStore" />
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="审核等级：" prop="approveClass">
                    <el-input disabled v-model="temp.approveClass" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="80">
                <el-col :span="11">
                  <el-form-item label="邀请状态：" prop="inviteStauts">
                    <el-select
                      v-model="inviteStauts"
                      clearable
                      placeholder="请选择"
                      disabled
                    >
                      <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="创建时间：" prop="createTime">
                    <el-input disabled v-model="temp.createTime" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane class="tab_style" :key="2" label="附件文件">
          <FileUpDown
            ref="FileUpDown"
            :bizId="venderinviteId"
            :bizType="FILE_BIZ_TYPE"
          ></FileUpDown>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button
          type="primary"
          @click="dataFormSubmit()"
          :loading="submitLoading"
          size="mini"
          v-if="showEditButton"
          >保 存</el-button
        >
        <el-button @click="dialogVisibleDetail = false" size="mini" v-if="!editflag"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createMtl, supplierInquiryList } from "@/controller/supplier";
import FileUpDown from "../../../common/file-up-down.vue";
export default {
  components:{
    FileUpDown
  },

  data() {
    return {
      viewData: {
        visible: true,
        width: "",
      },
      temp: {
                    venderinviteId : '',
                    venderName : '',
                    venderAdd : '',
                    venderContacts : '',
                    venderTel : '',
                    venderMail : ''
                },
      flag: "",
      dataList: [],
      dialogVisibleDetail: false,
      selectedRow: null,
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      venderinviteId: '',
      FILE_BIZ_TYPE:30,
      dataForm: {
        id: 0,
        materialGroupName: "",
        materialGroupCode: "",
        parentId: "",
        parentName: "",
        parentNodePath: "",
        tenantId: "",
        tenantName: "",
      },
      dataRule: {
        name: [
          { required: true, message: "物料名称不能为空", trigger: "blur" },
        ],
        code: [
          { required: true, message: "物料代码不能为空", trigger: "blur" },
        ],
      },
      style: {
        leftStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 325 + "px",
          overflow: "auto",
        },
        rightStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 205 + "px",
        },
        gridStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 350 + "px",
          width: parseInt(document.documentElement["clientWidth"]) - 100 + "px",
        },
      },
    };
  },
  mounted() {},

  activated() {
    this.flag = this.$route.params.gpsStatusvalflag;
    if (this.flag === "1") {
      this.checkCreated = true;
      this.checkInvited = false;
      this.checkInvitedRecall = false;
    }
    if (
      this.$route.query &&
      this.$route.query.gpsStatusval &&
      this.$route.query.gpsStatusval.length > 0
    ) {
      this.gpsStatusval = encodeURI(
        JSON.stringify(this.$route.query.gpsStatusval)
      );
    } else {
      this.gpsStatusval = "";
    }
    this.getDataList();
  },

  methods: {
    init() {
      this.viewData.visible = true;
      this.getDataList();
    },
    // 表单提交
    dataFormSubmit() {
      const row = this.selectedRow;
      this.$emit("closeDialog");
      this.$emit("supplierAdmitRow", row);
    },

    cancel() {
      this.$emit("closeDialog");
    },

    getDataList() {
      supplierInquiryList({
        inviteStauts: 0,
      })
        .then((data) => {
          if (data && data.code == "00") {
            this.dataList = data.body.records;
            console.log("data", this.dataList);
            this.totalPage = data.body.total;
          } else {
            this.dataList = [];
            this.totalPage = 0;
          }
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },

    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + this.pageSize * (this.pageIndex - 1);
    },

    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    //多选
    selectionChangeHandle(val) {
      console.log("val", val);
      this.dataListSelections = val;
    },

    venderUserDetail(row){
      console.log("hang",row)
      this.temp = Object.assign({}, row)
      this.dialogVisibleDetail = true;


    }
  },
};
</script>

<style lang="scss">
.el-dialog__body {
  .org-dialog-form {
    width: 95%;
  }
}
</style>
